import axios from 'axios'

export const VehicleService = {
  list
}

function list () {
  return axios.get(`vehicles/list`).then()
}
